<template>
  <div  style="box-shadow: none !important; overflow: hidden !important;" class="text-center">
    <v-dialog
    persistent
    style="box-shadow: none !important; overflow-y: hidden !important; padding: 0px"
      v-model="dialog"
      class="box"
      max-width="600"
      box-shadow="false"
    >
   
       <v-card
                      style="border-radius: 12px; overflow: hidden !important; box-shadow: none; width: 100%; margin: 0px !important;"
                      class=" ma-2 box"
                      color="lgrey"
                      elevation="4"
                      
                    >
                    <v-card-title class="text-h6 center" style=" background-color: #b22af0; justify-content: center;">
                            <span class="white--text center">Support Ticket Logged</span>
                           </v-card-title>

        <v-card-text class="center"  style="margin: 16px; justify-content: center;">
              <v-img
          width="150px"
          height="150px"
          class="mr-3"
          :src="require('@/assets/svgs/email-2.svg')"
        />
       Your support ticket has been logged with Strapp. Our support team will get back to you as soon as possible. Thank you.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions style="justify-content: center;">
      
    

            <v-hover v-slot="{ hover }">
                            <v-btn
                              v-bind="size"
                              class="appbutton mx-1 mt-3 white--text font-weight-medium"
                              :elevation="hover ? 16 : 4"
                              :class="{ 'on-hover': hover }"
                              color="accent"
                              rounded
                          @click="dialog = false, $router.go(-1)"
                            >
                            
                             Continue Strapping
                              </v-btn
                            >
                          </v-hover>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false,
      }
    },
    
    created(){
    this.dialog = true
  }

  }

  
</script>
<style scoped>
.box {
    box-shadow: none !important; overflow: hidden !important;
}
.center {
  display: grid;
  place-items: center;
}
</style>